<script>
import { cdmFieldsMethods } from '@state/helpers'
import _ from 'lodash'

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ...this.field,
      selectItems: [
        { text: 'Please select one', disabled: true },
        { text: 'String', value: 0 },
        { text: 'Decimal', value: 1 },
        { text: 'Date', value: 2 },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        caption: 'Caption',
        format: 'Data Format',
      }
    },
  },
  created() {
    this.originalField = {
      caption: this.field.caption,
      showInTable: this.field.showInTable,
      aggregate: this.field.aggregate,
      type: this.field.type,
      format: this.field.format,
      order: this.field.order,
      cdmNumber: this.field.cdmNumber,
    }

    this.tryUpdateField = _.debounce(this.tryUpdateField, 500)
  },
  methods: {
    ...cdmFieldsMethods,
    tryUpdateField() {
      var vm = this
      var toUpdate = this.field
      toUpdate.caption = this.caption
      toUpdate.showInTable = this.showInTable
      toUpdate.cdmNumber = this.cdmNumber
      toUpdate.aggregate = this.aggregate
      toUpdate.type = this.type
      toUpdate.format = this.format
      toUpdate.order = this.order
      return this.updateRevField(toUpdate)
        .then(updated => {
          vm.caption = updated.caption
          vm.showInTable = updated.showInTable
          vm.cdmNumber = updated.cdmNumber
          vm.aggregate = updated.aggregate
          vm.type = updated.type
          vm.format = updated.format
          vm.order = updated.order

          vm.originalField = updated
        })
        .catch(error => {
          this.updateError = error

          vm.caption = vm.originalField.caption
          vm.showInTable = vm.originalField.showInTable
          vm.type = vm.originalField.type
          vm.format = vm.originalField.format
          vm.aggregate = vm.originalField.aggregate
          vm.order = vm.originalField.order
          vm.cdmNumber = vm.originalField.cdmNumber
        })
    },
    updateShowInTable(checked) {
      this.showInTable = checked
      return this.tryUpdateField()
    },
    updateAggregate(checked) {
      this.aggregate = checked
      return this.tryUpdateField()
    },
    updateType(value) {
      this.type = value
      return this.tryUpdateField()
    },
    updateCdmNumber(checked) {
      this.cdmNumber = checked
      return this.tryUpdateField()
    },
  },
}

/*
    {
      name: 'Test',
      caption: 'Test Caption',
      showInTable: true,
      type: 0,
      format: null,
      order: 0,
      organizationId: 'c1ef359f-6bd0-4d12-8a3d-1522788ea43e',
      organization: null,
      id: '97b7bc83-e013-4041-8f16-3fb56989928d',
      stringId: '97b7bc83-e013-4041-8f16-3fb56989928d',
    }
*/
</script>

<template>
  <tr>
    <td colspan="1" :class="$style.drag">
      <v-icon>mdi-drag</v-icon>
    </td>
    <td colspan="2">{{ name }}</td>
    <td colspan="1">
      <v-checkbox
        v-model="cdmNumber"
        type="checkbox"
        color="cyan"
        @change="updateCdmNumber"
      />
    </td>
    <td colspan="2">
      <v-text-field
        v-model="caption"
        color="cyan"
        :placeholder="placeholders.caption"
        @input="tryUpdateField"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="showInTable"
        type="checkbox"
        color="cyan"
        @change="updateShowInTable"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="aggregate"
        type="checkbox"
        color="cyan"
        @change="updateAggregate"
      />
    </td>
    <td colspan="2">
      <v-select
        v-model="type"
        color="cyan"
        :items="selectItems"
        @input="updateType"
      ></v-select>
    </td>
    <td colspan="2">
      <v-text-field
        v-model="format"
        color="cyan"
        :placeholder="placeholders.format"
        @input="tryUpdateField"
      />
    </td>
  </tr>
</template>

<style lang="scss" module>
@import '@design';

.drag {
  cursor: move;
}
</style>
